<script>
  import {
    callQueue,
    activeSpec,
    unlockedSpecs,
    systemLog,
  } from "../../editor/storage.js";
  import { isEmptyRule } from "../../editor/callQueue.js";
  import {
    openSystemTooltip,
    closeSystemTooltip,
  } from "../../editor/utility.js";

  export let history;
  export let view = false;
  export let uid;
  export let statusBarControl;
  activeSpec.subscribe((u) => {
    if (u !== uid) {
      view = false;
      statusBarControl("versions", view);
    }
  });
  const icons = {
    manual: "pencil-fill",
    recommender: "stars",
    augment: "lightning-charge-fill",
    direct: "cursor-fill",
  };
</script>

{#if history?.constructor?.name === "Array"}
  <button
    type="button"
    style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;"
    class={"history" + (view ? " opened" : " closed")}
    on:click={() => {
      if ($unlockedSpecs.includes(uid)) {
        view = !view;
        $systemLog.log({
          message: "Toggled edit history view",
          artboard_id: uid,
          status: view,
        });
        statusBarControl("history", view);
      }
    }}
    on:mouseover={(event) => {
      if (!$unlockedSpecs.includes(uid)) {
        openSystemTooltip(
          event,
          "Unlock the artboard to see the edit history of this artboard"
        );
      } else {
        openSystemTooltip(
          event,
          (view ? "Close" : "Open") + " the edit history of this artboard"
        );
      }
    }}
    on:focus={(event) => {
      if (!$unlockedSpecs.includes(uid)) {
        openSystemTooltip(
          event,
          "Unlock the artboard to see the edit history of this artboard"
        );
      } else {
        openSystemTooltip(
          event,
          (view ? "Close" : "Open") + " the edit history of this artboard"
        );
      }
    }}
    on:mouseout={() => {
      closeSystemTooltip();
    }}
    on:blur={() => {
      closeSystemTooltip();
    }}><i class="bi bi-receipt me-1" />Edit history</button
  >
  {#if view}
    <div class="history-list">
      <div class="history-list-wrap">
        {#each history as h}
          {#if !isEmptyRule(h)}
            <div class="history-list-item">
              <div class="text-truncate">
                <i class={`bi bi-${icons[h.category || "manual"]} me-1`} />
                {h.description}
              </div>
              <button
                type="button"
                class="cancel"
                on:click={() => {
                  if (uid) {
                    $callQueue.cancel([uid], [h.callID]);
                    $systemLog.log({
                      message: "Redo",
                      artboard_id: uid,
                      call_id: h.callID,
                    });
                  }
                }}
              >
                <i class="bi bi-x" alt="cancel" />
              </button>
            </div>
          {/if}
        {/each}
      </div>
    </div>
  {/if}
{/if}

<style>
  .history {
    appearance: none;
    display: block;
    border: 0;
    background: transparent;
    font-size: 0.75rem;
    padding: 0.15rem 0.5rem;
  }
  .history:hover,
  .history.opened {
    background: rgba(255, 196, 34, 0.6);
  }
  .history-list {
    position: absolute;
    bottom: 0;
    right: -198px;
    width: 190px;
    height: 120px;
    overflow-y: scroll;
    border-radius: var(--default-radius);
    font-size: 0.75rem;
    background-color: #f9f9f9;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
    border: 1px solid #cccccc;
  }
  .history-list-wrap {
    display: flex;
    flex-direction: column-reverse;
    height: auto;
  }
  .history-list-item {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    padding: 0.25rem 0.5rem;
    border-bottom: 1px dashed #dddddd;
  }
  .history-list-item:hover {
    background-color: #fcfcfc;
  }
  .history-list-item:first-of-type {
    border-bottom: 0;
  }
  .cancel {
    appearance: none;
    border: 0;
    background: transparent;
    font-size: 0.75rem;
    padding: 0;
    margin-right: 0.4rem;
  }
</style>
